// PHP API Client
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080';

interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  message?: string;
  error?: string;
}

export async function apiRequest<T = any>(
  endpoint: string,
  options: RequestInit = {}
): Promise<T> {
  const token = localStorage.getItem('auth_token');

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  
  if (options.headers) {
    Object.assign(headers, options.headers);
  }

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const url = `${API_URL}${endpoint}`;
  
  const response = await fetch(url, {
    ...options,
    headers,
  });

  let result: ApiResponse<T>;
  try {
    const text = await response.text();
    result = JSON.parse(text);
  } catch (e) {
    throw new Error(`API error: ${response.status} ${response.statusText}`);
  }

  if (!response.ok || !result.success) {
    throw new Error(result.error || 'Request failed');
  }

  return result.data as T;
}

export async function apiUpload(file: File, subdir: string = ''): Promise<string> {
  const token = localStorage.getItem('auth_token');
  
  const formData = new FormData();
  formData.append('file', file);
  formData.append('subdir', subdir);

  const response = await fetch(`${API_URL}/upload.php`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData,
  });

  const result: ApiResponse<{ url: string }> = await response.json();

  if (!response.ok || !result.success) {
    throw new Error(result.error || 'Upload failed');
  }

  return result.data!.url;
}
